import * as http from '../../modules/http';
import {SALES_ITEM_LINES_CHANGED} from "./SalesItemActions";

export const PROVIDERS_REQUEST_START = 'PROVIDERS_REQUEST_START';
export const PROVIDERS_REQUEST_SUCCESS = 'PROVIDERS_REQUEST_SUCCESS';
export const PROVIDERS_REQUEST_FAILED = 'PROVIDERS_REQUEST_FAILED';
export const PROVIDERS_REQUEST_NO_PERMISSION = 'PROVIDERS_REQUEST_NO_PERMISSION';
export const PROVIDERS_OPEN_FORM = 'PROVIDERS_OPEN_FORM';
export const PROVIDER_DEAL_CHANGED = 'PROVIDER_DEAL_CHANGED';
export const PROVIDER_CHANGED = 'PROVIDER_CHANGED';
export const PROVIDERS_UPDATE_REQUEST_START = 'PROVIDERS_UPDATE_REQUEST_START';
export const PROVIDERS_UPDATE_REQUEST_SUCCESS = 'PROVIDERS_UPDATE_REQUEST_SUCCESS';
export const PROVIDER_NAME_CHANGED = 'PROVIDER_NAME_CHANGED';
export const PROVIDER_INSERT = 'PROVIDER_INSERT';
export const PROVIDER_UPDATE = 'PROVIDER_UPDATE';

export function providers_request_start() {
    return {
        type: PROVIDERS_REQUEST_START
    };
}

export function providers_request_success(data) {
    return {
        type: PROVIDERS_REQUEST_SUCCESS,
        data: data
    };
}

export function providers_update_request_start() {
    return {
        type: PROVIDERS_UPDATE_REQUEST_START
    };
}

export function providers_update_request_success(data) {

    return {
        type: PROVIDERS_UPDATE_REQUEST_SUCCESS,
        data: data
    };
}

export function providers_request_failed() {
    return {
        type: PROVIDERS_REQUEST_FAILED
    };
}

export function providers_request_no_permission() {
    return {
        type: PROVIDERS_REQUEST_NO_PERMISSION
    };
}

export function providers_open_form(provider) {
    return {
        type: PROVIDERS_OPEN_FORM,
        provider: provider

    };
}

export function provider_name_changed(field, value) {
    return {
        type: PROVIDER_NAME_CHANGED,
        value: value,
        field: field
    };
}

export function provider_insert(data) {
    return {
        type: PROVIDER_INSERT,
        data:data
    };
}

export function provider_update(data, index) {
    return {
        type: PROVIDER_UPDATE,
        data:data,
        index:index
    };
}

export function fetchProvidersDataIfNeeded() {

    return (dispatch, getState) => {
        if (shouldFetchProvidersData()) {
            return dispatch(fetchProvidersData());
        }
    };
}


export function provider_changed(change, field, value, index) {
    return {
        type: PROVIDER_CHANGED,
        change: change,
        field: field,
        value: value,
        index: index,
    };
}


export function provider_deal_changed(field, value, index) {
    return {
        type: PROVIDER_DEAL_CHANGED,
        field: field,
        value: value,
        index: index,
    };
}

function shouldFetchProvidersData() {
    return true;
}

function fetchProvidersData() {
    return ((dispatch) => {
        dispatch(providers_request_start());

        return http.postToServer('providers/get',
            {},
            (response) =>  {dispatch(providers_request_success(response.data))},
            (response) =>  {console.log("Failed request"); dispatch(providers_request_failed())},
            (response) =>  {dispatch(providers_request_no_permission())}

        );

    });
}